import { useResource } from "@rest-hooks/core";
export function usePrefetchResources(component, props, placeholder) {
    const prefetchResources = component.getPrefetch?.(props) ?? [];
    const resources = placeholder
        ? prefetchResources.map(r => [r[0], null])
        : prefetchResources;
    return useResource(...resources);
}
//# sourceMappingURL=usePrefetchResources.js.map